(function () {
  'use strict';

  var root = document.querySelector('[data-tm-qv]');
  if (!root) return;

  var dialog = root.querySelector('[data-tm-qv-dialog]');
  var loadingEl = root.querySelector('[data-tm-qv-loading]');
  var errorEl = root.querySelector('[data-tm-qv-error]');
  var bodyEl = root.querySelector('[data-tm-qv-body]');
  var mainEl = root.querySelector('[data-tm-qv-main]');
  var slidesEl = root.querySelector('[data-tm-qv-slides]');
  var prevBtn = root.querySelector('[data-tm-qv-prev]');
  var nextBtn = root.querySelector('[data-tm-qv-next]');
  var dotsEl = root.querySelector('[data-tm-qv-dots]');
  var thumbsEl = root.querySelector('[data-tm-qv-thumbs]');
  var thumbsWrap = root.querySelector('[data-tm-qv-thumbs-wrap]');
  var tPrevBtn = root.querySelector('[data-tm-qv-tprev]');
  var tNextBtn = root.querySelector('[data-tm-qv-tnext]');
  var titleEl = root.querySelector('[data-tm-qv-title]');
  var priceCurrent = root.querySelector('[data-tm-qv-price-current]');
  var priceCompare = root.querySelector('[data-tm-qv-price-compare]');
  var priceSave = root.querySelector('[data-tm-qv-save]');
  var ratingEl = root.querySelector('[data-tm-qv-rating]');
  var optionsEl = root.querySelector('[data-tm-qv-options]');
  var variantInput = root.querySelector('[data-tm-qv-variant-id]');
  var qtyInput = root.querySelector('[data-tm-qv-qty]');
  var atcBtn = root.querySelector('[data-tm-qv-atc]');
  var form = root.querySelector('[data-tm-qv-form]');
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var currencySymbol = root.getAttribute('data-currency-symbol') || '$';

  var product = null;
  var selected = [];
  var lastFocus = null;
  /* Growth Lab: personalization guard + post-add feedback */
  var currentPersonalized = false;
  var currentProductUrl = '';
  var toastEl = null;
  var toastTimer = null;

  function looksPersonalized(title) {
    var t = String(title || '').toLowerCase();
    return t.indexOf('personaliz') !== -1 || t.indexOf('custom name') !== -1;
  }

  function pdpUrlFor(handle) {
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return rootPath + 'products/' + encodeURIComponent(handle);
  }

  function showToast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tm-qv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.style.cssText =
        'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:100000;' +
        'background:#111;color:#fff;padding:12px 18px;border-radius:10px;font-size:14px;' +
        'line-height:1.3;box-shadow:0 10px 30px rgba(0,0,0,.25);max-width:calc(100% - 32px);';
      document.body.appendChild(toastEl);
    }
    var cartUrl = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
    toastEl.innerHTML = '';
    toastEl.appendChild(document.createTextNode(message + ' '));
    var link = document.createElement('a');
    link.href = cartUrl;
    link.textContent = 'View cart';
    link.style.cssText = 'color:#fff;text-decoration:underline;margin-left:6px;';
    toastEl.appendChild(link);
    toastEl.hidden = false;
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toastEl.hidden = true;
    }, 4000);
  }

  /* Open the theme's mini-cart drawer (the header cart icon carries
     data-drawer-options '{ "id":"#t4s-mini_cart" }'); fall back to a toast. */
  function openCartDrawerOrToast() {
    var drawer = document.getElementById('t4s-mini_cart');
    var trigger = document.querySelector('[data-drawer-options*="t4s-mini_cart"]');
    if (drawer && trigger) {
      window.setTimeout(function () {
        trigger.click();
      }, 250);
      return;
    }
    showToast('Added to cart.');
  }

  /* --- Slider state --- */
  var galleryImages = [];
  var currentSlide = 0;
  var scrollRaf = null;
  var resizeRaf = null;
  var isSliderScrolling = false;

  function formatMoney(cents) {
    var amount = (Number(cents) / 100).toFixed(2);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, moneyFormat);
      } catch (e) { /* fall through */ }
    }
    if (moneyFormat.indexOf('{{amount}}') !== -1) {
      return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
    }
    return currencySymbol + amount;
  }

  /* -----------------------------------------------------------------------
   * Color resolution — ported from the PDP/PLP swatch fallback logic so
   * Quick View renders the exact same colors. Order of precedence mirrors
   * PDP's JS fallback chain:
   *   1. ThreadMug named-color overrides (Crunchberry, Blue Jean, etc.)
   *   2. Native CSS color keyword resolution (browser-parsed)
   *   3. Broad color-family keyword matching
   *
   * NOTE: PDP's *first* priority on the server is Shopify's native
   * Color-category swatch metafield (value.swatch.color), read via Liquid.
   * The /products/{handle}.js AJAX endpoint Quick View uses does not expose
   * metafield data, so that exact-RGB source can't be replicated client-side
   * from this payload. Everything below matches PDP's fallback path, which
   * is what PDP itself uses whenever a variant doesn't have that metafield.
   * --------------------------------------------------------------------- */

  var customColors = {
    'black': '#25282a',
    'crunchberry': '#ef4a81',
    'butter': '#f5e1a4',
    'bay': '#94a596',
    'blossom': '#f8bed6',
    'blue jean': '#647692',
    'blue spruce': '#3e5d58',
    'chili': '#893c47',
    'graphite': '#1d252d',
    'ivory': '#e7ceb5',
    'moss': '#22372b',
    'orchid': '#c7b2de',
    'pepper': '#4e4b48',
    'watermelon': '#f4364c',
    'espresso': '#553c36',
    'light green': '#5c7f71',
    'grey': '#716e6a',
    'gray': '#716e6a',
    'crimson': '#a4123f',
    'chambray': '#bdd6e6',
    'chalky mint': '#5cb8b2',
    'terracotta': '#e3775e',
    'denim': '#425563',
    'white': '#ffffff',
    'navy': '#0c2340'
  };

  var familyColors = [
    { keys: ['burgundy', 'maroon', 'wine'], color: '#800020' },
    { keys: ['pink', 'rose', 'fuchsia', 'magenta'], color: '#e83e8c' },
    { keys: ['purple', 'violet', 'plum', 'lilac', 'lavender'], color: '#8e6bbf' },
    { keys: ['blue', 'azure', 'cyan', 'aqua', 'teal', 'turquoise'], color: '#3f7ea3' },
    { keys: ['green', 'mint', 'olive', 'sage', 'lime', 'forest'], color: '#5c7f71' },
    { keys: ['yellow', 'gold', 'mustard'], color: '#d7b43a' },
    { keys: ['orange', 'coral', 'peach', 'apricot'], color: '#e0784d' },
    { keys: ['red', 'scarlet', 'ruby'], color: '#b52b35' },
    { keys: ['brown', 'tan', 'beige', 'camel', 'khaki'], color: '#9a7653' },
    { keys: ['black', 'charcoal'], color: '#25282a' },
    { keys: ['white', 'snow', 'cream'], color: '#f7f7f2' },
    { keys: ['gray', 'grey', 'silver'], color: '#716e6a' }
  ];

  function normalizeColorName(name) {
    return String(name || '')
      .toLowerCase()
      .trim()
      .replace(/[‐-―−_-]+/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function browserCssColor(name) {
    var normalized = normalizeColorName(name);
    if (!normalized) return '';

    var candidates = [
      normalized,
      normalized.replace(/\s+/g, ''),
      normalized.replace(/\s+/g, '-'),
      normalized.replace(/\s+/g, '_')
    ];
    var probe = document.createElement('span');
    probe.style.position = 'absolute';
    probe.style.left = '-99999px';
    probe.style.width = '1px';
    probe.style.height = '1px';
    probe.style.visibility = 'hidden';
    document.body.appendChild(probe);

    for (var i = 0; i < candidates.length; i++) {
      probe.style.backgroundColor = '';
      probe.style.backgroundColor = candidates[i];
      if (probe.style.backgroundColor) {
        var resolved = getComputedStyle(probe).backgroundColor;
        if (resolved && resolved !== 'rgba(0, 0, 0, 0)' && resolved !== 'transparent') {
          document.body.removeChild(probe);
          return resolved;
        }
      }
    }
    document.body.removeChild(probe);
    return '';
  }

  function swatchColor(name) {
    var normalized = normalizeColorName(name);
    if (!normalized) return '';

    if (customColors[normalized]) return customColors[normalized];

    var parsed = browserCssColor(normalized);
    if (parsed) return parsed;

    for (var i = 0; i < familyColors.length; i++) {
      for (var j = 0; j < familyColors[i].keys.length; j++) {
        if (normalized.indexOf(familyColors[i].keys[j]) !== -1) return familyColors[i].color;
      }
    }
    return '#d9cfc3';
  }

  function isColorOption(name) {
    var n = String(name || '').toLowerCase();
    return n.indexOf('color') !== -1 || n.indexOf('colour') !== -1;
  }

  function uniqueOptionValues(optionIndex) {
    var key = 'option' + (optionIndex + 1);
    var seen = {};
    var values = [];
    product.variants.forEach(function (variant) {
      var val = variant[key];
      if (val && !seen[val]) {
        seen[val] = true;
        values.push(val);
      }
    });
    return values;
  }

  function valueAvailable(optionIndex, value) {
    return product.variants.some(function (variant) {
      if (variant['option' + (optionIndex + 1)] !== value) return false;
      if (!variant.available) return false;
      return selected.every(function (sel, i) {
        if (i === optionIndex || !sel) return true;
        return variant['option' + (i + 1)] === sel;
      });
    });
  }

  function findVariant() {
    return product.variants.find(function (variant) {
      return selected.every(function (value, i) {
        return !value || variant['option' + (i + 1)] === value;
      });
    }) || product.variants[0];
  }

  /* --- Gallery / slider --- */

  function normalizeSrc(src) {
    return String(src || '').split('?')[0];
  }

  function renderGallery() {
    var images = (product.images && product.images.length)
      ? product.images.slice()
      : (product.featured_image ? [product.featured_image] : []);

    galleryImages = images.map(function (src) {
      return typeof src === 'string' ? src : (src && src.src) || '';
    }).filter(Boolean);

    slidesEl.innerHTML = '';
    thumbsEl.innerHTML = '';
    dotsEl.innerHTML = '';
    currentSlide = 0;

    if (!galleryImages.length) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
      dotsEl.hidden = true;
      return;
    }

    galleryImages.forEach(function (src, index) {
      var slide = document.createElement('div');
      slide.className = 'tm-qv__slide';
      var img = document.createElement('img');
      img.src = src;
      img.alt = product.title;
      img.loading = index === 0 ? 'eager' : 'lazy';
      slide.appendChild(img);
      slidesEl.appendChild(slide);

      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'tm-qv__thumb' + (index === 0 ? ' is-active' : '');
      thumb.setAttribute('role', 'listitem');
      thumb.setAttribute('aria-label', 'View image ' + (index + 1));
      var thumbImg = document.createElement('img');
      thumbImg.src = src;
      thumbImg.alt = product.title;
      thumbImg.loading = 'lazy';
      thumb.appendChild(thumbImg);
      thumb.addEventListener('click', function () {
        goToSlide(index, true);
      });
      thumbsEl.appendChild(thumb);

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tm-qv__dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('role', 'listitem');
      dot.setAttribute('aria-label', 'Go to image ' + (index + 1));
      dot.addEventListener('click', function () {
        goToSlide(index, true);
      });
      dotsEl.appendChild(dot);
    });

    var multiple = galleryImages.length > 1;
    prevBtn.hidden = !multiple;
    nextBtn.hidden = !multiple;
    dotsEl.hidden = !multiple;
    updateArrowState();
    if (thumbsEl) thumbsEl.scrollLeft = 0;
    scheduleThumbNav();
  }

  /* 2026-10-02: thumbnail strip — no native scrollbar; chevrons + edge fade when there are more. */
  var thumbNavRaf = null;
  function updateThumbNav() {
    if (!thumbsEl || !thumbsWrap) return;
    var max = thumbsEl.scrollWidth - thumbsEl.clientWidth;
    var hasPrev = max > 1 && thumbsEl.scrollLeft > 1;
    var hasNext = max > 1 && thumbsEl.scrollLeft < max - 1;
    thumbsWrap.classList.toggle('has-prev', hasPrev);
    thumbsWrap.classList.toggle('has-next', hasNext);
    if (tPrevBtn) tPrevBtn.hidden = !hasPrev;
    if (tNextBtn) tNextBtn.hidden = !hasNext;
  }
  function scheduleThumbNav() {
    if (thumbNavRaf) return;
    thumbNavRaf = window.requestAnimationFrame(function () {
      thumbNavRaf = null;
      updateThumbNav();
    });
  }
  function pageThumbs(dir) {
    if (!thumbsEl) return;
    var first = thumbsEl.querySelector('.tm-qv__thumb');
    var gap = parseFloat(getComputedStyle(thumbsEl).columnGap) || 0;
    var step = first ? first.getBoundingClientRect().width + gap : thumbsEl.clientWidth;
    var per = Math.max(1, Math.floor((thumbsEl.clientWidth + gap + 1) / step));
    thumbsEl.scrollBy({ left: dir * per * step, behavior: 'smooth' });
  }
  function revealThumb(index) {
    if (!thumbsEl) return;
    var t = thumbsEl.children[index];
    if (!t) return;
    var left = t.offsetLeft - thumbsEl.offsetLeft;
    var right = left + t.offsetWidth;
    if (left < thumbsEl.scrollLeft) {
      thumbsEl.scrollTo({ left: left, behavior: 'smooth' });
    } else if (right > thumbsEl.scrollLeft + thumbsEl.clientWidth) {
      thumbsEl.scrollTo({ left: right - thumbsEl.clientWidth, behavior: 'smooth' });
    }
  }
  if (thumbsEl) thumbsEl.addEventListener('scroll', scheduleThumbNav, { passive: true });
  if (tPrevBtn) tPrevBtn.addEventListener('click', function () { pageThumbs(-1); });
  if (tNextBtn) tNextBtn.addEventListener('click', function () { pageThumbs(1); });

  function updateActiveIndex(index) {
    currentSlide = index;

    thumbsEl.querySelectorAll('.tm-qv__thumb').forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
    dotsEl.querySelectorAll('.tm-qv__dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === index);
    });

    revealThumb(index);
    updateArrowState();
  }

  function updateArrowState() {
    if (prevBtn.hidden) return;
    prevBtn.disabled = currentSlide <= 0;
    nextBtn.disabled = currentSlide >= galleryImages.length - 1;
  }

  function goToSlide(index, smooth) {
    if (!galleryImages.length) return;
    index = Math.max(0, Math.min(galleryImages.length - 1, index));
    var width = slidesEl.clientWidth;
    isSliderScrolling = true;
    slidesEl.scrollTo({ left: index * width, behavior: smooth ? 'smooth' : 'auto' });
    updateActiveIndex(index);
    /* release the "programmatic scroll" flag after the scroll settles */
    window.clearTimeout(goToSlide._t);
    goToSlide._t = window.setTimeout(function () {
      isSliderScrolling = false;
    }, smooth ? 350 : 50);
  }

  function findSlideIndexForSrc(src) {
    var target = normalizeSrc(src);
    var index = galleryImages.findIndex(function (imgSrc) {
      var s = normalizeSrc(imgSrc);
      return s === target || s.indexOf(target) !== -1 || target.indexOf(s) !== -1;
    });
    return index;
  }

  slidesEl.addEventListener('scroll', function () {
    if (scrollRaf) return;
    scrollRaf = window.requestAnimationFrame(function () {
      scrollRaf = null;
      var width = slidesEl.clientWidth;
      if (!width) return;
      var index = Math.round(slidesEl.scrollLeft / width);
      if (index !== currentSlide) updateActiveIndex(index);
    });
  }, { passive: true });

  prevBtn.addEventListener('click', function () {
    goToSlide(currentSlide - 1, true);
  });
  nextBtn.addEventListener('click', function () {
    goToSlide(currentSlide + 1, true);
  });

  window.addEventListener('resize', function () {
    if (root.hidden) return;
    if (resizeRaf) window.cancelAnimationFrame(resizeRaf);
    resizeRaf = window.requestAnimationFrame(function () {
      goToSlide(currentSlide, false);
      updateThumbNav();
    });
  });

  /* --- Options --- */

  function optionLabel(option) {
    if (typeof option === 'string') return option;
    if (option && typeof option === 'object') return option.name || option.value || '';
    return String(option || '');
  }

  function renderOptions() {
    optionsEl.innerHTML = '';
    selected = [];

    var options = product.options || [];
    if (
      options.length === 1 &&
      (optionLabel(options[0]) === 'Title' || optionLabel(options[0]) === 'Default Title')
    ) {
      return;
    }

    options.forEach(function (option, optionIndex) {
      var optionName = optionLabel(option);
      var values = (option && option.values && option.values.length)
        ? option.values.map(optionLabel)
        : uniqueOptionValues(optionIndex);

      var wrap = document.createElement('div');
      wrap.className = 'tm-qv__option';
      wrap.setAttribute('data-option-index', String(optionIndex));

      var label = document.createElement('span');
      label.className = 'tm-qv__label';
      label.textContent = optionName + (isColorOption(optionName) ? '' : '*');
      wrap.appendChild(label);

      var color = isColorOption(optionName);
      var list = document.createElement('div');
      list.className = color ? 'tm-qv__swatches' : 'tm-qv__pills';
      list.setAttribute('role', 'list');

      /* Prefer first available variant's option values */
      var preferred = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      selected[optionIndex] = preferred
        ? preferred['option' + (optionIndex + 1)]
        : (values.find(function (v) { return valueAvailable(optionIndex, v); }) || values[0]);

      values.forEach(function (value) {
        var available = valueAvailable(optionIndex, value);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-tm-qv-option-value', value);
        btn.setAttribute('data-tm-color-value', value);
        btn.setAttribute('role', 'listitem');

        if (color) {
          btn.className = 'tm-qv__swatch' + (value === selected[optionIndex] ? ' is-selected' : '') + (!available ? ' is-disabled' : '');
          btn.style.setProperty('--tm-swatch', swatchColor(value));
          btn.setAttribute('aria-label', value);
          btn.innerHTML = '<span class="tm-qv__swatch-dot"></span><span class="tm-qv__swatch-name"></span>';
          btn.querySelector('.tm-qv__swatch-name').textContent = value;
        } else {
          btn.className = 'tm-qv__pill' + (value === selected[optionIndex] ? ' is-selected' : '') + (!available ? ' is-disabled' : '');
          btn.textContent = value;
        }

        if (!available) btn.disabled = true;

        btn.addEventListener('click', function () {
          selected[optionIndex] = value;
          list.querySelectorAll('[data-tm-qv-option-value]').forEach(function (b) {
            b.classList.toggle('is-selected', b === btn);
          });
          updateVariant();
          refreshOptionAvailability();
        });

        list.appendChild(btn);
      });

      wrap.appendChild(list);
      optionsEl.appendChild(wrap);
    });
  }

  function refreshOptionAvailability() {
    optionsEl.querySelectorAll('.tm-qv__option').forEach(function (wrap) {
      var optionIndex = Number(wrap.getAttribute('data-option-index'));
      wrap.querySelectorAll('[data-tm-qv-option-value]').forEach(function (btn) {
        var value = btn.getAttribute('data-tm-qv-option-value');
        var available = valueAvailable(optionIndex, value);
        btn.disabled = !available;
        btn.classList.toggle('is-disabled', !available);
      });
    });
  }

  function updateVariant() {
    var variant = findVariant();
    if (!variant) return;

    variantInput.value = variant.id;
    priceCurrent.textContent = formatMoney(variant.price);

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceCompare.hidden = false;
      priceSave.hidden = false;
      priceCompare.textContent = formatMoney(variant.compare_at_price);
      priceSave.textContent = 'SAVE ' + formatMoney(variant.compare_at_price - variant.price);
    } else {
      priceCompare.hidden = true;
      priceSave.hidden = true;
    }

    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to Cart' : 'Sold out';
    }

    if (variant.featured_image) {
      var src = typeof variant.featured_image === 'string'
        ? variant.featured_image
        : (variant.featured_image.src || '');
      if (src) {
        var index = findSlideIndexForSrc(src);
        if (index !== -1) goToSlide(index, true);
      }
    }
  }

  /* 2026-10-02: delivery box for the product's supplier (templates rendered by the snippet). */
  var tmQvDeliveryEl = root.querySelector('[data-tm-qv-delivery]');
  var TM_QV_M = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var TM_QV_W = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function tmQvAddBusinessDays(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    var count = 0;
    while (count < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) count++;
    }
    return d;
  }
  function tmQvVendorKey(vendor) {
    var v = String(vendor || '').toLowerCase();
    if (v.indexOf('eprolo') !== -1) return 'eprolo';
    if (v.indexOf('vossagin') !== -1) return 'vossagin';
    if (v.indexOf('shineon') !== -1) return 'shineon';
    if (v.indexOf('travellty') !== -1 || v.indexOf('parker kids') !== -1) return 'travellty';
    if (v.indexOf('rosec') !== -1) return 'rosec';
    return 'printify';
  }
  function renderDelivery(vendor) {
    if (!tmQvDeliveryEl) return;
    tmQvDeliveryEl.innerHTML = '';
    var tpl = document.querySelector('template[data-tm-qv-delivery-tpl="' + tmQvVendorKey(vendor) + '"]');
    if (!tpl || !tpl.content) return;
    var frag = tpl.content.cloneNode(true);
    Array.prototype.forEach.call(frag.querySelectorAll('script'), function (s) {
      s.parentNode.removeChild(s);
    });
    tmQvDeliveryEl.appendChild(frag);
    /* refresh dates in the shopper's own time */
    Array.prototype.forEach.call(tmQvDeliveryEl.querySelectorAll('[data-tm-delivery]'), function (el) {
      var min = parseInt(el.getAttribute('data-min-bd'), 10);
      var max = parseInt(el.getAttribute('data-max-bd'), 10);
      var out = el.querySelector('[data-tm-delivery-range]');
      if (!out || !(min > 0) || !(max >= min)) return;
      var a = tmQvAddBusinessDays(min);
      var b = tmQvAddBusinessDays(max);
      out.textContent =
        TM_QV_W[a.getDay()] + ', ' + TM_QV_M[a.getMonth()] + ' ' + a.getDate() + ' – ' +
        TM_QV_W[b.getDay()] + ', ' + TM_QV_M[b.getMonth()] + ' ' + b.getDate();
    });
  }

  function setState(state, message) {
    loadingEl.hidden = state !== 'loading';
    errorEl.hidden = state !== 'error';
    bodyEl.hidden = state !== 'ready';
    if (state === 'error') errorEl.textContent = message || 'Unable to load product.';
  }

  function openModal() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('tm-qv-open');
    if (dialog) dialog.focus();
  }

  function closeModal() {
    root.hidden = true;
    document.body.classList.remove('tm-qv-open');
    product = null;
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function productUrl(handle) {
    var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return rootPath + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function openQuickView(handle, shortTitle, opts) {
    if (!handle) return;
    opts = opts || {};
    currentPersonalized = !!opts.personalized;
    currentProductUrl = opts.url || pdpUrlFor(handle);
    if (currentPersonalized) {
      window.location.href = currentProductUrl;
      return;
    }
    openModal();
    setState('loading');
    qtyInput.value = '1';

    fetch(productUrl(handle), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(function (data) {
        product = data;
        if (looksPersonalized(product.title)) currentPersonalized = true;
        if (product.url) currentProductUrl = product.url;
        titleEl.textContent = shortTitle || product.title;
        if (ratingEl) {
          ratingEl.innerHTML =
            '<div class="tm-jdgm-badge jdgm-widget jdgm-preview-badge" data-id="' +
            product.id +
            '"></div>';
          if (window.jdgm && typeof window.jdgm.customizeWidgets === 'function') {
            window.jdgm.customizeWidgets();
          } else if (window.jdgm && typeof window.jdgm.LOAD_WIDGETS === 'function') {
            window.jdgm.LOAD_WIDGETS();
          }
        }
        renderGallery();
        renderOptions();
        updateVariant();
        try { renderDelivery(product.vendor); } catch (e) {}
        /* 2026-10-02: wishlist heart follows the loaded product */
        var tmWishBtn = root.querySelector('[data-tm-wish]');
        if (tmWishBtn) {
          tmWishBtn.setAttribute('data-id', String(product.id));
          tmWishBtn.setAttribute('data-handle', product.handle || handle);
          if (window.TMWishlist && typeof window.TMWishlist.sync === 'function') window.TMWishlist.sync();
        }
        setState('ready');
        /* make sure the slider is aligned to slide 0 once layout has settled */
        window.requestAnimationFrame(function () {
          goToSlide(0, false);
          updateThumbNav();
        });
      })
      .catch(function () {
        setState('error', 'Unable to load this product. Please try again.');
      });
  }

  /*   Triggers: [data-tm-quickview] or Personalize it links with data-product-handle */
  document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-tm-quickview]');
  if (!trigger) return;
  event.preventDefault();

  var handle = trigger.getAttribute('data-product-handle') || trigger.getAttribute('data-tm-quickview');
  var shortTitle = trigger.getAttribute('data-product-short-title');

  if (!handle && trigger.getAttribute('href')) {
    var match = trigger.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (match) handle = match[1];
  }

  openQuickView(handle, shortTitle, {
    personalized: trigger.getAttribute('data-tm-personalized') === 'true',
    url: trigger.getAttribute('data-product-url') || ''
  });
});

  root.querySelectorAll('[data-tm-qv-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden) return;
    if (event.key === 'Escape') closeModal();
    if (event.key === 'ArrowLeft' && !prevBtn.hidden) goToSlide(currentSlide - 1, true);
    if (event.key === 'ArrowRight' && !nextBtn.hidden) goToSlide(currentSlide + 1, true);
  });

  root.querySelector('[data-tm-qv-qty-minus]').addEventListener('click', function () {
    qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
  });
  root.querySelector('[data-tm-qv-qty-plus]').addEventListener('click', function () {
    qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1));
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var id = variantInput.value;
    var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    if (!id || atcBtn.disabled) return;
    if (currentPersonalized) {
      /* Personalized items need Globo options on the product page. */
      window.location.href = currentProductUrl || (product && product.url) || '/';
      return;
    }

    errorEl.hidden = true;
    var original = atcBtn.textContent;
    atcBtn.disabled = true;
    atcBtn.textContent = 'Adding…';

    var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var tmAddedTitle = (titleEl && titleEl.textContent) || '';
    var tmAddedProductId = product && product.id;
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(id), quantity: qty })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Add failed');
          return data;
        });
      })
      .then(function (line) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('t4s:cart:refresh', { bubbles: true }));
        closeModal();
        /* 2026-10-02: same "Added to your cart" panel as the product page; old drawer/toast as fallback. */
        if (window.TMAddedPanel && typeof window.TMAddedPanel.show === 'function') {
          try {
            window.TMAddedPanel.show(line, { title: tmAddedTitle, productId: tmAddedProductId });
            return;
          } catch (e) {}
        }
        openCartDrawerOrToast();
      })
      .catch(function (err) {
        if (err && err.message && err.message !== 'Add failed') {
          setState('ready');
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }
        atcBtn.textContent = 'Try again';
        setTimeout(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = original;
        }, 1200);
      })
      .finally(function () {
        if (!root.hidden) {
          var variant = findVariant();
          atcBtn.disabled = !(variant && variant.available);
          if (atcBtn.textContent === 'Adding…') atcBtn.textContent = original;
        }
      });
  });

  window.TMQuickView = { open: openQuickView, close: closeModal };
})();